import React from "react";

import ListHeader from "../../edpOps/issuanceIDcard/studentList/ListHeader";
import AddToFavourite from "../../homepage/favourites/AddToFavourite";
import { pages } from "../../common/constant";

import VendorCards from "./VendorCards";
import { VendorMgmtProvider } from "./context";
import SearchForVendors from "./SearchForVendors";

const index = () => {
  return (
    <VendorMgmtProvider>
      <div
        className="d-flex flex-column remove-container-top-space"
        // style={{ minHeight: "calc(100vh - 79px)" }}
      >
        <div className="p-3 student-filer-container-printId">
          <div className="d-flex justify-content-between align-items-center">
            <ListHeader text="Search for vendors" />
            <AddToFavourite
              screenId={pages["vendorManagement"]["id"]}
              screenName={pages["vendorManagement"]["name"]}
            />
          </div>
          <SearchForVendors />
        </div>
      </div>

      <div className="screen-cards-container">
        <VendorCards />
      </div>
    </VendorMgmtProvider>
  );
};

export default index;
